import { ddeApi } from '@/service/ddeApi'
import { StandarizedGolfPlayer } from '@/views/DataAdmin/types'
import { ddePlayerToStandarized } from '@/views/DataAdmin/utils'

import { createBaseTableStore } from '../table'
import { FetchApiArgs, FetchApiResponse } from '../table/table.types'

type AnalyticsFiltersParams = 'firstName' | 'lastName'

const fetchPlayersApiCallback = async (
  args: FetchApiArgs<object, string, AnalyticsFiltersParams>
): Promise<FetchApiResponse<StandarizedGolfPlayer>> => {
  const { signal, page, pageSize, filters } = args

  const firstName = filters.firstName?.[0].value ? String(filters.firstName?.[0].value) : undefined

  const lastName = filters.lastName?.[0].value ? String(filters.lastName?.[0].value) : undefined

  const { data } = await ddeApi.endpoints.golf.getPlayers({
    params: {
      page,
      pageSize,
      firstName,
      lastName
    },
    signal
  })

  return {
    content: data.players.map(ddePlayerToStandarized),
    totalElements: data.totalResultsAvailable
  }
}

export const usePlayers = createBaseTableStore({
  storeName: 'Players',
  fetchApi: fetchPlayersApiCallback,
  features: {
    pagination: true,
    filtering: true
  }
})
